"use client";

import type { ParsedUrlQueryInput } from "node:querystring";

import { useRouter } from "@packages/i18n";
import { URL_ONBOARDING } from "@packages/sdk";
import { useEffect } from "react";

const makeQuery = (
  str: string,
): Record<string, ParsedUrlQueryInput[keyof ParsedUrlQueryInput]> => {
  const query: Record<string, any> = {};

  if (str?.length) {
    const params = new URLSearchParams(str);
    for (const [key, val] of params) {
      query[key] = val;
    }
  }

  return query;
};
export const PortalClientRedirect = () => {
  const router = useRouter();

  useEffect(() => {
    if (typeof window !== "undefined") {
      const hash = window.location.hash;
      if (!hash?.length)
        router.replace({
          pathname: URL_ONBOARDING,
          query: makeQuery(window.location.search),
        });
      else {
        const [path, queryString] = hash.split("?");
        const query = makeQuery(queryString);
        const elements = path.split("/");
        switch (elements[elements.length - 1]) {
          case "":
          case "forgotpass":
          case "home":
          case "idme":
          case "prayerplan":
          case "user":
          case "info":
          case "profile":
            router.replace({ pathname: "/settings/account/profile", query });
            break;
          case "billing":
          case "checkout":
            router.replace({ pathname: "/subscribe/checkout", query });
            break;
          case "payment":
            if (elements[elements.length - 2] === "gift")
              router.replace({ pathname: "/gift/checkout", query });
            router.replace({ pathname: "/settings/payment", query });
            break;
          case "friends":
          case "hallow-plus":
          case "sms":
          case "subscribe":
          case "web-subscriptions":
          case "year":
            router.replace({ pathname: "/subscribe", query });
            break;
          case "cancel":
          case "cancelled":
          case "confirm":
          case "family":
          case "plans":
          case "subscription":
            router.replace({ pathname: "/web/settings/subscription", query });
            break;
          case "hdp":
          case "redeem":
            router.replace({ pathname: "/redeem", query });
            break;
          case "coppa":
            router.replace({ pathname: "/register/coppa", query });
            break;
          case "delete":
            router.replace({ pathname: "/settings/account/delete", query });
            break;
          case "email":
            if (elements[elements.length - 2] === "verify")
              router.replace({ pathname: "/verify/email", query });
            router.replace({ pathname: "/settings/account/email", query });
            break;
          case "gift":
            router.replace({ pathname: "/gift", query });
            break;
          case "language":
            router.replace({ pathname: "/settings/language", query });
            break;
          case "legal":
            router.replace({ pathname: "/settings/legal", query });
            break;
          case "merge":
            router.replace({ pathname: "/settings/account/merge", query });
            break;
          case "notre-dame":
            router.replace({
              pathname: "/register/university/notre-dame",
              query,
            });
            break;
          case "password":
            router.replace({ pathname: "/settings/account/password", query });
            break;
          case "phone":
            router.replace({ pathname: "/settings/account/phone", query });
            break;
          case "referrals":
          case "resources":
            router.replace({
              pathname: "/settings/referrals/dashboard",
              query,
            });
            break;
          case "prizes":
            router.replace({ pathname: "/settings/referrals/prizes", query });
            break;
          case "preferences":
            router.replace({
              pathname: "/settings/account/manage-email-preferences",
              query,
            });
            break;
          case "support":
            router.replace({ pathname: "/settings/support", query });
            break;
          case "download":
          case "webapp":
            router.replace({ pathname: "/home", query });
            break;
          case "login":
          case "phonecode":
          case "phonelogin":
            router.replace({ pathname: "/login", query });
            break;
          case "launch":
          case "register":
          case "create-account":
            const urlSearchParams = new URLSearchParams(
              window.location.href.split("?")[1],
            );
            router.replace(`${URL_ONBOARDING}?${urlSearchParams.toString()}`);
            break;
          default:
            switch (elements[elements.length - 2]) {
              case "invite":
                router.replace({
                  pathname: `/invite/${elements[elements.length - 1]}`,
                  query,
                });
                break;
              case "resetpass":
                router.replace({
                  pathname: `/resetpassword/${elements[elements.length - 1]}`,
                  query,
                });
                break;
              default:
                router.replace({ pathname: "/", query });
            }
        }
      }
    }
  }, []);

  return <></>;
};
